<template>
    <div class="container-fluid">
        <div class="mt-2 tabName">
            <h3>{{ $t('create_custom_medication') }}</h3>
        </div>
        <CustomMedicationForm
            :customMedication="customMedication"
            :key="formKey"
            @submit="submit"
            submitButtonName="create_custom_medication"
        />
    </div>
</template>

<script>
import { createCustomMedication, handleAxiosError } from '@/services/axiosService';
import CustomMedicationForm from './CustomMedicationForm';

export default {
    components: {
        CustomMedicationForm
    },
    data() {
        return {
            customMedication: {
                active: true,
                atc: '',
                chemical: '',
                company: '',
                company_reseller: '',
                dosage: '',
                dosage_form: '',
                drug: false,
                form: '',
                name: '',
                package_size: '',
                supplier: '',
                vnr: 'P'
            },
            formKey: 0,
            loaded: false
        };
    },
    methods: {
        // submit: create custom med, show notification and redirect to index page
        async submit() {
            try {
                await createCustomMedication({
                    ...this.customMedication,
                    vnr: this.customMedication.vnr.toUpperCase()
                });
                this.$toastr.s(this.$t('custom_medication_created'));
                this.$router.push({ name: 'customMedications.index' });
            } catch (error) {
                handleAxiosError(error);
                this.formKey = this.formKey + 1;
            }
        }
    }
};
</script>
